import { isWebpageRoute } from "../../shared/stepConfig";
import type { ParsedStep } from "./parseCommitData";

/**
 * Ordering rank (ascending) for isolated steps in the workflow canvas band, so
 * user-facing entry points lead. Webpage routes get primacy, then other
 * callable routes, then automated triggers, then plain steps.
 */
export function rankIsolatedStep(step: ParsedStep): number {
  if (isWebpageRoute(step.routeType)) return 0;
  if (step.routeType !== null || step.publicRoute !== null) return 1;
  if (step.schedule !== null || step.emailAddress !== null) return 2;
  return 3;
}
